import { parseAbi } from 'viem';

// Contract Addresses
export const STAKING_CONTRACT = '0x53b5567dB4b180A7Fc19e5F12DD29d22fA2C595a';
export const LRST_TOKEN = '0x6421355286Ecb21Ad502582Cd0B0DA16971D5F45';

// MasterChef ABI (essential functions)
export const MASTERCHEF_ABI = parseAbi([
  // Read functions
  'function poolLength() view returns (uint256)',
  'function poolInfo(uint256 pid) view returns (address stakingToken_, uint256 allocPoint_, uint256 totalStaked_, uint256 accRewardPerShare_)',
  'function userPosition(uint256 pid, address account) view returns (uint256 staked, uint256 debt, uint256 unpaid, uint256 claimable, uint256 lastHarvest)',
  'function pendingReward(uint256 pid, address account) view returns (uint256)',
  'function rewardRate() view returns (uint256)',
  'function totalAllocPoint() view returns (uint256)',
  'function canHarvest(uint256 pid, address account) view returns (bool)',
  'function totalEmitted() view returns (uint256)',
  'function emittedRewards() view returns (uint256)',
  'function remainingRewards() view returns (uint256)',
  'function HARVEST_INTERVAL() view returns (uint256)',
  
  // Write functions
  'function stake(uint256 pid, uint256 amount)',
  'function unstake(uint256 pid, uint256 amount)',
  'function harvest(uint256 pid)',
  'function emergencyWithdraw(uint256 pid)',
  
  // Events
  'event Staked(address indexed user, uint256 indexed pid, uint256 requested, uint256 received)',
  'event Unstaked(address indexed user, uint256 indexed pid, uint256 amount, uint256 fee)',
  'event Harvested(address indexed user, uint256 indexed pid, uint256 reward)',
  'event EmergencyWithdraw(address indexed user, uint256 indexed pid, uint256 amount)'
]);

// ERC20 ABI for staking tokens
export const ERC20_STAKING_ABI = parseAbi([
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address) view returns (uint256)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function approve(address spender, uint256 amount) returns (bool)',
  'function transfer(address to, uint256 amount) returns (bool)',
  'event Approval(address indexed owner, address indexed spender, uint256 value)',
  'event Transfer(address indexed from, address indexed to, uint256 value)'
]);

// Token Logo Detection Sources
export const TOKEN_LOGO_SOURCES = [
  {
    name: 'TrustWallet',
    getUrl: (chainId, address) => 
      `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/${address}/logo.png`
  },
  {
    name: 'PancakeSwap',
    getUrl: (chainId, address) => 
      `https://tokens.pancakeswap.finance/images/${address}.png`
  }
];

// Default token logos (known tokens)
const LRST_LOWER = LRST_TOKEN.toLowerCase();
const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';
const LP_TOKEN_ADDRESS = '0x16fdB137A9874655BbBa5BF1160DC967c6F3f4ed';

export const DEFAULT_TOKEN_LOGOS = {
  [LRST_LOWER]: 'https://customer-assets.emergentagent.com/job_dapp-modernize/artifacts/xu3aml61_F4A0E702-38AF-4DC5-A5AD-BB4BB87298E5.png',
  [WBNB_ADDRESS.toLowerCase()]: 'https://tokens.pancakeswap.finance/images/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c.png', // WBNB
  // LP Pool logo (LRST/BNB)
  [LP_TOKEN_ADDRESS.toLowerCase()]: 'https://customer-assets.emergentagent.com/job_dapp-modernize/artifacts/a13f6vs8_F9A70DB2-6F2B-4AAB-AC95-92B245ACC54A.png'
};

// BSC Block time (average 3 seconds)
export const BSC_BLOCK_TIME = 3;

// Blocks per year
export const BLOCKS_PER_YEAR = (365 * 24 * 60 * 60) / BSC_BLOCK_TIME;
